/**
 * The collection of i18n strings.
 *
 * @since 0.1.0
 */
export const I18N = {
  indentNotice  : 'Indent/Move Focus',
  indentDisabled: 'Inserting indents by the Tab is currently disabled. You can toggle it by %s.',
};
